export function useStringUtils () {
  function capitalize (string) {
    if (!string || typeof string !== 'string') {
      return ''
    }
    return string.charAt(0).toUpperCase() + string.slice(1)
  }

  function trim (str, ch) {
    ch = ch || ' '
    let start = 0
    let end = str.length

    while (start < end && str[start] === ch) { ++start }

    while (end > start && str[end - 1] === ch) { --end }

    return (start > 0 || end < str.length) ? str.substring(start, end) : str
  }
  return {
    capitalize,
    trim
  }
}



// WEBPACK FOOTER //
// ./src/commons/stringsUtil.js